<template>
  <div v-if="isLoadingParts || (!isLoadingParts && (partSearchModel.CategoryParts.length > 0 || inStockFilter))" id="CategoryPartSearch" class="category-part-search cps">
    <b-col class="col-sm-12">
      <b-row v-if="partSearchModel.NumberOfResults > 0 || inStockFilter" class="cps__upper-sort-row">
        <pagination-text 
          :page-size="selectedResultsPerPage"
          :current-page="partSearchModel.CurrentPageNumber"
          :number-of-results="partSearchModel.NumberOfResults"
          context="categoryPartSearch"
          css-classes="col col-md-2 col-sm-6 col-xs-6 cps__pagination-column"
          class="cps__upper-pagination"
        />
        <b-col class="cps__pagination-column col-md-2 col-sm-12 col-xs-12">
          <select
            id="parts-per-page-list"
            v-model="selectedResultsPerPage"
            class="cps__select-results-per-page"
            @change="resultsPerPageSelected"
          >
            <option
              v-for="resultCount in resultsPerPage"
              :key="resultCount.value"
              :value="resultCount.value"
            >
              {{ resultCount.displayText }}
            </option>
          </select>
          per page
        </b-col>
        <b-col class="cps__pagination-column col-md-4 col-sm-12 col-xs-12 pb-2">
          <select 
            id="sort-term-list"
            v-model="selectedSortTerm"
            class="cps__select-sort-term"
            @change="sortTermSelected"
          > 
            <option 
              v-for="sortTerm in sortByOptions" 
              :key="sortTerm.value" 
              :value="sortTerm.value"
              :disabled="sortTerm.disabled"
            >
              {{ sortTerm.displayText }}
            </option>      
          </select>
        </b-col>
        <b-col class="cps__inStock-toggle col-md-2">
          In Stock
          <input
            id="inStockToggle"
            v-model="inStockFilter"
            type="checkbox"
            text="In Stock"
            @change="performPartSearch"
          >
        </b-col>
        <b-col class="col-12 col-md-2 p-0">
          <b-pagination 
            v-model="partSearchModel.CurrentPageNumber"
            :total-rows="rows"
            :per-page="selectedResultsPerPage"
            align="right"
            aria-controls="categoryParts"
            size="sm"
            :disabled="isLoadingParts"
            @input="performNextPagePartSearch"
          />
        </b-col>
      </b-row>
      <hr>
      <b-row v-if="isLoadingNextPageParts || (isLoadingParts && !disableLoadingSpinner)" class="justify-content-center">
        <loading-spinner />
      </b-row>
      <b-row v-else class="no-gutters">
        <!-- START category part -->
        <!-- If not grid view -->
        <b-col v-if="!gridView" class="col-12">
          <b-row v-for="part in partSearchModel.CategoryParts" id="categoryParts" :key="part.Id" class="cps__row">
            <part-info v-if="part.FullPartDetails" :part="part" class="cps__part" />
            <skeleton-loader v-else/>
            <div class="col-12 p-0">
              <hr>
            </div>
          </b-row>
        </b-col>
        <!-- grid view -->
        <b-col v-else>
          <b-row v-for="row in partSearchModel.GridCategoryParts" id="categoryParts" :key="row.index">
            <div 
              v-for="part in row" 
              id="categoryPartsCol" 
              :key="part.id" 
              class="cps__part-tile">
              <part-info-grid v-if="part.FullPartDetails" :part="part" class="cps__part-grid" />
              <skeleton-loader v-else />
            </div>
          </b-row>
        </b-col>
        <!-- END category part -->
      </b-row>
      <br>
      <b-row v-if="partSearchModel.NumberOfResults > 0">
        <pagination-text 
          :page-size="selectedResultsPerPage"
          :current-page="partSearchModel.CurrentPageNumber"
          :number-of-results="partSearchModel.NumberOfResults"
          context="categoryPartSearch"
          css-classes="col col-12 col-md-6 cps__pagination-column"
        />
        <b-col class="col-12 col-md-6 p-0">
          <b-pagination 
            v-model="partSearchModel.CurrentPageNumber"
            :total-rows="rows"
            :per-page="selectedResultsPerPage"
            align="right"
            aria-controls="categoryParts"
            :disabled="isLoadingParts"
            size="sm"
          />
        </b-col>
      </b-row>
    </b-col>
  </div>
</template>

<script>
  import LoadingSpinner        from "@/components/Elements/LoadingSpinner"
  import { PartInfo }          from "@/components/Elements/PartInfo"
  import { PartInfoGrid }      from "@/components/Elements/PartInfoGrid"
  import PaginationText        from "@/components/Elements/PaginationText"
  import {ShoppingCartService} from "@/services/ShoppingCartService"
  import { 
    DnFunctionButton
  }         from "@/components/Elements";
  import {PartListService}     from "@/services/PartListService"
import SkeletonLoader from "@/components/Elements/SkeletonLoader.vue";
  import { ErrorLogService }   from "@/services/ErrorLogService"
  import { stringHelper }      from "@/components/mixins/stringHelper"
  import {mapGetters}          from "vuex"
  import {constants}           from "@/const" 
  import { create }            from 'lodash'

  export default {
    components: {
      LoadingSpinner,
      PaginationText,
      PartInfo,
      PartInfoGrid,
      SkeletonLoader,
    },
    mixins: [stringHelper],
    props: {
      partSearchModel: {
        type: Object,
        default: () => ({
          CategoryParts: {
            type: Array,
            default: Array            
          },
          GridCategoryParts: {
            type: Array,
            default: Array
          },
          Facets: {
            type: Object,
            default: Object
          }, 
          NumberOfPages: {
            type: Number,
            default: Number
          }, 
          NumberOfResults: {
            type: Number,
            default: Number
          }, 
          CurrentPageNumber: {
            type: Number,
            default: 1
          },
          isAddFacet: {
            type: Boolean,
            default: false
          },
        })
      },
      disableLoadingSpinner: {
        type: Boolean,
        default: false 
      },
      gridView: {
        type: Boolean,
        default: false
      },
    },
    data: () => ({
      isLoadingParts: true,
      isLoadingNextPageParts: false,
      addToCartQuantity: {},
      selectedPartList: null,
      createNewPartListName: "",
      currentlyAddingPartToList: false,
      resultsPerPage: constants.RESULTS_PER_PAGE,
      selectedResultsPerPage: 10,
      defaultSortTerm: "",
      defaultSortDirection: "",
      selectedSortTerm: "",
      sortByOptions: constants.SORT_BY_OPTIONS,
      inStockFilter: false,
    }),
    computed: {
      ...mapGetters([
        "user",
        "activeAccountId", 
        "IsMcfa", 
        "IsMcfe", 
        "IsMcfs", 
        "tenantDetails",
        "cartSummary", 
        "getContentItem", 
        "partsLists", 
        "hasPermission", 
        "facingWarehouse",
        "CurrentCategory",
        "partSearchDefaultSortValue"
      ]),
      rows() {
        return this.partSearchModel.NumberOfResults;
      },      

    },
    created: function() {     
      this.setDefaultSort();
      this.sortTermSelected();
      this.$store.dispatch("LOAD_PARTS_LISTS");
    },
    methods: {
      setDefaultSort(){
        // Load User defaults
        this.selectedSortTerm = this.partSearchDefaultSortValue;
        if( this.selectedSortTerm !== ""){
          // Don't load category defaults if the user has specified the setting
          return;  
        }

        // Load Category defaults
        let defaultSortTerm = this.CurrentCategory.DefaultSortTerm;
        let defaultSortDirection = this.CurrentCategory.DefaultSortDirection;
        if( defaultSortTerm && defaultSortDirection ){
          this.selectedSortOption = this.sortByOptions.find(option => 
            option.sortKey === defaultSortTerm && option.sortDirection === defaultSortDirection
          )
          this.selectedSortTerm = this.selectedSortOption.value;
        }
      },
      resultsPerPageSelected(){ 
        this.$emit("resultsPerPageChanged", this.selectedResultsPerPage)
        this.performPartSearch();
      },
      sortTermSelected(){ 
        this.selectedSortOption = this.sortByOptions.find(option => option.value === this.selectedSortTerm);
        this.$emit("sortTermChanged", this.selectedSortOption) 
        this.performPartSearch();       
      }, 
      performPartSearch() {
        this.isLoadingParts = true;
        this.$emit("partSearch", this.getCategoryParts, this.selectedSortOption?.sortKey, this.selectedSortOption?.sortDirection, this.selectedResultsPerPage, this.inStockFilter)
      },
      performNextPagePartSearch() {
        this.isLoadingNextPageParts = true;
        this.performPartSearch();
      },
      clickedPartListButton(part){
        this.resetPartListData();
      },
    }
  }
</script>

<style lang="scss">
.cps__part-tile{
  padding: 0px 0px 15px 5px;
  width: 200px !important;
}
.cps__upper-sort-row{
  padding-top: 10px;
}

.cps__pagination-column{
  padding: 10px 0px 0px 0px;
}

.cps__inStock-toggle{
   padding-top: 10px;
}
.cps__part-grid{
  min-height: 390px;

}
.active{
  z-index: 0;
}

.cps__row{
  padding-top: 1rem;
  border-bottom: 1px solid lightgray;
}
</style>
